import { sendBucketEvent } from 'client/javascript/heap';
import { isMobileBreakpoint } from 'client/javascript/util/device_breakpoints';

export const EXPERIMENT_KEY = 'mobile_nav_bar';

export function setupMobileNavBarExperimentBucketing() {
  if (isMobileBreakpoint()) {
    sendBucketEvent(EXPERIMENT_KEY);
  }
}
